import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import Grid from '@mui/material/Grid'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import InfoIcon from '@mui/icons-material/Info'
import { Divider, ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import HeaderConditions from './about/HeaderConditions'
import HeaderPrivacity from './about/HeaderPrivacity'
import LinkMUI from '@mui/material/Link'
import { useTheme } from '@mui/material'
import useClasses from '../../hooks/UseClasses'
import config from '@/config/env'

const styles = (theme) => ({
  imagen: {
    marginLeft: '2rem',
    width: '8rem',
  },
  link: {
    textDecoration: 'underline !important',
    '&:hover': {
      color: theme.palette.text.success.color + ' !important',
      textDecoration: 'none !important',
    },
  },
})

const { ENVIRONMENT } = config
let pjson = require('../../../../package.json')

const HeaderAbout = () => {
  const theme = useTheme()
  const [info, setInfo] = useState(false)
  const { t } = useTranslation()

  const handleAbout = () => {
    setInfo(true)
  }

  const classes = useClasses(styles)
  return (
    <LinkMUI color="primary" underline="hover">
      <MenuItem onClick={handleAbout}>
        <ListItemIcon>
          <InfoIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t('HEADER.ABOUT')} />
      </MenuItem>
      <Dialog
        open={info}
        onClose={() => setInfo(false)}
        maxWidth={'lg'}
        slotProps={{ paper: { style: { width: '50rem', borderRadius: '0.375rem' } } }}
        style={{
          borderRadius: '0.375rem',
          boxShadow: theme.customShadows.medium,
        }}>
        <Grid
          container
          style={{
            backgroundColor: theme.palette.background.primary.color,
            padding: '2rem',
          }}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <img className={classes.imagen} src="/ico.png" />
          </Grid>
          <Grid size={{ xs: 12, sm: 8 }}>
            <Typography variant="h3" style={{ color: theme.palette.text.light.color }}>
              <b> {ENVIRONMENT}</b>
            </Typography>
            <Typography style={{ color: 'white' }} variant="h5">
              {pjson.version}
            </Typography>
          </Grid>
          <Grid size={12} style={{ padding: '1rem 2rem' }}>
            <Typography align="justify" style={{ color: theme.palette.text.light.color }}>
              {t('HEADER.EXTENDED')}
            </Typography>
          </Grid>
        </Grid>
        <Divider
          style={{
            backgroundColor: theme.palette.background.primaryLight.color,
            height: '0.0625rem',
          }}
          flexItem
        />
        <Grid
          container
          style={{
            backgroundColor: theme.palette.background.primary.color,
            gap: '3rem',
            justifyContent: 'center',
            padding: '1rem',
          }}>
          <HeaderConditions />
          <HeaderPrivacity />
        </Grid>
      </Dialog>
    </LinkMUI>
  )
}

export default HeaderAbout
